import { observer } from 'mobx-react';
import baseInfo from '@stores/index.js';
import React from 'react';

function sureTipFun(operate) {
    let tipWinArr = baseInfo.tipWinArr;
    if (tipWinArr.length > 0) {
        if (
            operate == 'confirm' &&
            tipWinArr[0].sureCallBack &&
            typeof tipWinArr[0].sureCallBack == 'function'
        ) {
            tipWinArr[0].sureCallBack();
        }

        baseInfo.setTipWinArr({}, -1);
    }
}

const TipBox = observer(({ popupsBorder, baseInfo }) => {
    return (
        <div
            id="tip_box"
            className="win_box"
            style={{ display: baseInfo.tipWinArr.length > 0 ? 'block' : 'none' }}
        >
            {popupsBorder && <img className="top-img" src={popupsBorder}></img>}
            <div className="win-wrap">
                <a
                    className="close"
                    onClick={() => {
                        sureTipFun('close');
                    }}
                ></a>
                <div className="win_content">
                    <div
                        className="content_txt"
                        dangerouslySetInnerHTML={{
                            __html: baseInfo.tipWinArr.length > 0 ? baseInfo.tipWinArr[0].text : ''
                        }}
                    ></div>
                </div>
                <div className="win_bottom">
                    <a
                        className="confirm btn"
                        onClick={() => {
                            sureTipFun('confirm');
                        }}
                    >
                        确认
                    </a>
                </div>
            </div>
        </div>
    );
});

export default TipBox;
